
import { Options, Vue } from "vue-class-component";
import { normalizeLangFromRoute } from "@/utils/locale";
import { loadLocaleData } from "@/utils/localeDataLoader";

@Options({
  name: "Page404",
  props: {
    keyWord: {
      type: String,
    },
  },
})
export default class Page404 extends Vue {
  protected keyWord!: string;

  protected get subtitleText(): string {
    return this.keyWord
      ? (this.$t("page404.withKeyword", { keyWord: this.keyWord }) as string)
      : (this.$t("page404.withoutKeyword") as string);
  }

  async created(): Promise<void> {
    const lang = normalizeLangFromRoute(this.$route);
    await loadLocaleData(lang, ["menu"]);
  }
}
